import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AddressModal from "../../home/homeSearchBox/addressModel"
import RangePicker from "../../../components/comment/rangepicker/rangePicker"
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const headerBokingList = () => {
  return (
    <section className='header-car-booking-list'>
    <div className="bottom-nav ">
    <Container>
     <Row>
         <Col lg={6}>
                 <AddressModal icon= {<LocationOnOutlinedIcon className='location-input-icon'/>}/>
         </Col>
         <Col lg={6}>
                 <RangePicker />
         </Col>
     </Row>
    </Container>
     </div>
     </section>
  )
}

export default headerBokingList